module.exports = __webpack_public_path__ + "img/wordcloud-francesco-marzullo.ced10738.png";